import { SiteCatalog } from '../models/siteCatalog';
import { getCatalogs } from './getCatalogs';

export function getCatalogForSite(shortCode: string): Promise<SiteCatalog> {
  if (!shortCode) {
    return Promise.reject(new Error('No short code provided'));
  }

  return getCatalogs().then(data => {
    const matchingCatalog = data.find(catalog => catalog.shortCode === shortCode);

    if (!matchingCatalog) {
      throw new Error(`No catalog found for short code: ${shortCode}`);
    }

    return matchingCatalog;
  });
}
